import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import StatusPage from '../components/StatusPage';
import { intentAPI } from '../services/api';
import { responseData } from '../services/apiResponse';
import { Home } from 'lucide-react';

const LinkRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const linkToken = searchParams.get('linkToken');

  useEffect(() => {
    if (!linkToken) {
      setError({ code: 'LINK_NOT_FOUND', detail: 'This payment link is invalid or has been removed.' });
      setLoading(false);
      return;
    }

    const fetchIntent = async () => {
      try {
        const response = await intentAPI.getIntentByLink(linkToken);
        const requestId = responseData(response).request_id;
        navigate(`/welcome/${encodeURIComponent(requestId)}?linkToken=${encodeURIComponent(linkToken)}`, { replace: true });
      } catch (err) {
        const data = err.response?.data || {};
        setError({
          code: data.error || 'INTERNAL_ERROR',
          detail: data.detail || 'The payment request could not be loaded.',
        });
        setLoading(false);
      }
    };

    fetchIntent();
  }, [linkToken, navigate]);

  if (loading) {
    return (
      <Layout>
        <div className="text-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading payment request...</p>
        </div>
      </Layout>
    );
  }

  if (error) {
    const status = {
      LINK_EXPIRED: { variant: 'warning', title: 'Payment Link Expired' },
      REQUEST_INACTIVE: { variant: 'blocked', title: 'Payment Request Unavailable' },
      LINK_NOT_FOUND: { variant: 'neutral', title: 'Link Not Found' },
      INTERNAL_ERROR: { variant: 'error', title: 'Unable to Load Payment Request' },
    }[error.code] || { variant: 'error', title: 'Unable to Load Payment Request' };
    return (
      <StatusPage
        variant={status.variant}
        title={status.title}
        description={error.detail}
        actions={[{ label: 'Go to Home', icon: Home, onClick: () => navigate('/login') }]}
      />
    );
  }

  return null;
};

export default LinkRedirect;
